<template>
  <b-card no-body>
    <b-tabs card>
      <b-tab :title="$translate('import_headers_and_details')" class="p-0" active>
        <b-tabs align="center" card>
          <b-tab :title="$translate('import_headers')" class="p-0" active>
            <b-row class="mt-3">
              <b-col>
                <a href="javascript:void(0)" id="export-activity-header-csv" class="decoration-off text-success" @click="exportActivityHeaderCSV"><i
                    class="fas fa-file-excel fa-lg me-2"></i>{{ $translate('download_empty_csv_activity_header_template_here') }}</a>
              </b-col>
              <b-col>
              <a href="javascript:void(0)" id="export-activity-details-csv" class="decoration-off text-success" @click="exportActivityDetailsCSV"><i
                  class="fas fa-file-excel fa-lg me-2"></i>{{ $translate('download_empty_csv_activity_details_template_here') }}</a>
            </b-col>
            </b-row>
            <b-card-body class="p-0 mt-3">
              <form-wizard
                shape="tab"
                color="#3498db"
                title=""
                :subtitle="$translate('import_activities_note')"
                @on-complete="onComplete"
                @on-loading="setLoading"
              >
                <tab-content
                  :title="$translate('import_headers')"
                  :beforeChange="() => !!headerDataList.length"
                >
                  <simple-csv-import
                    v-model="headerDataList"
                    :startRowNo="orderHeaderSettings.rowno"
                    :columnsMap="headerColumnsMap"
                    :placeHolderText="$translate('import_header_file_placeholder')"
                    dropPlaceHolderText="Drop Header File Here..."
                  >
                  </simple-csv-import>
    
                  <p class="mt-4 mb--1" v-show="headerDataList.length">
                    <b>{{ $translate("total_records") }}</b>
                    {{ headerDataList.length }}&nbsp;&nbsp;&nbsp;&nbsp;
                    <i v-show="headerDataList.length > 5">{{
                      $translate("total_records_note")
                    }}</i>
                  </p>
                  <b-table
                    :items="headerDataList.slice(0, 5)"
                    :fields="fieldData"
                    responsive
                  >
                  </b-table>
                </tab-content>
                <tab-content
                  :title="$translate('import_details')"
                  :beforeChange="processUploadData"
                >
                  <div class="d-flex mb-2">
                    <div
                      class="form-check ps-sm-2 me-2"
                      :key="'Import ' + item.item"
                      v-for="item in detailOptions"
                    >
                      <label class="form-check-label">
                        <input
                        id="item-name"
                          type="radio"
                          class="form-check-input"
                          name="name"
                          v-model="detailType"
                          :value="item.item"
                        />
                        {{ item.name }}
                        <i class="input-helper"></i>
                      </label>
                    </div>
                  </div>
                  <template v-if="detailType == DetailedTypes.Upload">
                    <simple-csv-import
                      v-model="detailsDataList"
                      :startRowNo="orderDetailsSettings.rowno"
                      :columnsMap="detailsColumnsMap"
                      :placeHolderText="
                        $translate('import_details_file_placeholder')
                      "
                      dropPlaceHolderText="Drop Header File Here..."
                    >
                    </simple-csv-import>
    
                    <p class="mt-4 mb--1" v-show="detailsDataList.length">
                      <b>{{ $translate("total_records") }}</b>
                      {{ detailsDataList.length }}&nbsp;&nbsp;&nbsp;&nbsp;
                      <i v-show="detailsDataList.length > 5">{{
                        $translate("total_records_note")
                      }}</i>
                    </p>
                    <b-table
                      :items="detailsDataList.slice(0, 5)"
                      responsive
                    ></b-table>
                  </template>
                  <b-row v-if="detailType == DetailedTypes.Template">
                    <b-col
                      v-for="item in orderTemplateArray"
                      :key="'order-template-' + item.order_type_id"
                      cols="12"
                      class="dd"
                    >
                      <label
                        :id="`fieldset-${item.order_type_id}`"
                        :for="`template-select-${item.order_type_id}`"
                        class="mb-3"
                        >{{
                          `Template for
                                            ${item.order_type_name}`
                        }}</label
                      >
                      <b-form-select
                        class="form-control"
                        :id="`template-select-${item.order_type_id}`"
                        v-model="item.order_template_id"
                        :options="item.filtered_templates"
                        text-field="name"
                        value-field="id"
                      >
                      </b-form-select>
                    </b-col>
                  </b-row>
                </tab-content>
                <tab-content
                  v-if="hasPermissionUpdate"
                  :title="$translate('upload')"
                  :before-change="uploadOrders"
                >
                  <h6>{{ $translate("items_to_be_uploaded") }}</h6>
                  <b-table responsive :fields="i_fields" :items="i_orders">
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(upload_status)="data">
                      <b-badge
                        :id="`upload-order-${data.index}`"
                        :variant="data.value | filterStatusVariant"
                        >{{ data.value }}</b-badge
                      >
                      <!-- Show tooltip if there are errors -->
                      <b-popover
                        v-if="data.item.error_list.length > 0"
                        :target="`upload-order-${data.index}`"
                        triggers="hover"
                        placement="left"
                      >
                        <template #title> {{ $translate("errors") }}</template>
                        <ul>
                          <li
                            v-for="error_set in data.item.error_list"
                            :key="error_set.index"
                          >
                            {{ error_set }}
                          </li>
                        </ul>
                      </b-popover>
                    </template>
                  </b-table>
                  <b-progress class="mt-2" :max="i_orders.length">
                    <b-progress-bar
                      :value="completedUploads"
                      variant="success"
                    ></b-progress-bar>
                    <b-progress-bar
                      :value="failedUploads"
                      variant="danger"
                    ></b-progress-bar>
                  </b-progress>
                </tab-content>
                <tab-content :title="$translate('complete')">
                  <h6>{{ $translate("report") }}</h6>
                  <b-list-group>
                    <b-list-group-item
                      >{{ $translate("total_activities") }}
                      {{ i_orders.length }}</b-list-group-item
                    >
    
                    <b-list-group-item variant="success"
                      >{{ $translate("successful_uploads") }}
                      {{ completedUploads }}</b-list-group-item
                    >
                    <b-list-group-item variant="danger"
                      >{{ $translate("failed_uploads") }}
                      {{ failedUploads }}</b-list-group-item
                    >
                  </b-list-group>
                </tab-content>
                <div class="text-center">
                  <b-spinner
                    v-if="uploading"
                    variant="success"
                    label="Spinning"
                  ></b-spinner>
                </div>
              </form-wizard>
            </b-card-body>
          </b-tab>
          <b-tab :title="$translate('settings')" class="p-0">
            <b-card-body class="p-0 mt-3">
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="mb-1" role="tab">
                    <b-button
                     id="headers-settings"
                      block
                      v-b-toggle.header-accordion
                      variant="info"
                      class="w-100"
                      v-if="hasPermissionUpdate"
                      >{{ $translate("headers_settings") }}</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="header-accordion"
                    visible
                    accordion="settings-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <upload-data-settings
                        key="headers"
                        subject="Activity-header"
                        @input="updateDataSettings($event, true)"
                        :value="orderHeaderSettings"
                        :data-fields="orderHeaderFields"
                        ref="headerUploadDataSettings"
                      ></upload-data-settings>
                    </b-card-body>
                  </b-collapse>
                </b-card>
    
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" role="tab">
                    <b-button
                     id="details-settings"
                      block
                      v-b-toggle.details-accordion
                      variant="info"
                      class="w-100"
                      v-if="hasPermissionUpdate"
                      >{{ $translate("details_settings") }}</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="details-accordion"
                    accordion="settings-accordion"
                    role="tabpanel"
                  >
                    <b-card-body class="p-0 mt-3">
                      <upload-data-settings
                        key="details"
                        subject="Activity-details"
                        @input="updateDataSettings($event)"
                        :value="orderDetailsSettings"
                        :data-fields="orderDetailsFields"
                        ref="detailsUploadDataSettings"
                      ></upload-data-settings>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-card-body>
          </b-tab>
        </b-tabs>
        </b-tab>
        <b-tab :title="$translate('import_headers')" class="p-0">
          <ImportOrdersFormSimple  @cancel_model="onComplete"/>
        </b-tab>
    </b-tabs>
   
  </b-card>
</template>

<script>
import moment from "moment";
import { capitalCase } from "change-case";
const countryLookup = require("country-code-lookup");
const accounting = require("accounting");
import SimpleCsvImport from "@/components/SimpleCsvImport";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import UploadDataSettings from "@/components/UploadDataSettings";
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import dateTimeMixins from "../../mixins/dateTimeMixins";
import ImportOrdersFormSimple from "./ImportOrdersFormSimple.vue";
/**
 * The allowed date formats that can be parsed for the schedule at field
 */
const allowedDateFormats = [
  "DD/MM/YYYY",
  "D/M/YYYY",
  "MM/DD/YYYY",
  "M/D/YYYY",
  "YYYY-MM-DD",
  "MM/DD/YY",
  "M/D/YY",
  "D/M/YY",
  "DD/MM/YY",
  "DD-MMM-YY",
  "DD-MMM-YYYY",
  "MMMM DD, YYYY",
];

// Order field names and whether they are required
const orderHeaderFields = [
  { name: "reference_no", label: "reference_no", required: true },
  { name: "customer_code", label: "customer_code", required: true },
  { name: "customer_name", label: "customer_name", required: true },
  { name: "customer_email", label: "customer_email", required: false },
  { name: "customer_phone", label: "customer_phone", required: false },
  { name: "customer_address1", label: "customer_address1", required: false },
  { name: "customer_address2", label: "customer_address2", required: false },
  { name: "customer_city", label: "customer_city", required: false },
  { name: "customer_country", label: "customer_country", required: false },
  { name: "description", label: "description", required: true },
  { name: "officer_name", label: "officer_name", required: true },
  { name: "schedule_at", label: "schedule_at", required: true },
  {
    name: "schedule_at_date_format",
    label: "schedule_at_date_format",
    required: true,
    options: allowedDateFormats.map((dateFormat) => ({
      value: dateFormat,
      text: moment().clone().format(dateFormat),
    })),
  },
  { name: "order_type", label: "activity_type", required: true },
  { name: "total_price", label: "total_price", required: true },
  { name: "total_tax", label: "total_tax", required: false },
];

const orderDetailsFields = [
  { name: "customer_code", label: "customer_code", required: true },
  { name: "reference_no", label: "reference_no", required: true },
  { name: "item_code", label: "item_code", required: true },
  { name: "item_name", label: "item_name", required: true },
  { name: "description", label: "description", required: false },
  { name: "item_type", label: "item_type", required: true },
  { name: "quantity", label: "quantity", required: true },
  { name: "price", label: "price", required: true },
  { name: "tax_rate", label: "tax_rate", required: false },
  { name: "tax_amount", label: "tax_amount", required: false },
];

/**
 * Posible statuses during upload
 */
const statuses = {
  COMPLETE: "complete",
  PENDING: "pending",
  INVALID_LOCATION: "complete: invalid location",
  ERROR: "error: hover for details",
};

const DetailedTypes = { None: 0, Upload: 1, Template: 2 };

export default {
  name: "orders-importForm",
  components: {
    FormWizard,
    TabContent,
    SimpleCsvImport,
    UploadDataSettings,
    ImportOrdersFormSimple
  },
  mixins: [popupMixins, permissionsMixins, dateTimeMixins],
  props: [],
  data: () => {
    return {
      DetailedTypes,
      detailType: DetailedTypes.Upload,
      //headers
      orderHeaderSettings: {},
      orderHeaderFields,
      headerDataList: [],
      //details
      orderDetailsSettings: {},
      orderDetailsFields,
      detailsDataList: [],
      //generals
      i_orders: [],
      orderTemplateArray: [],
      componentName: "Orders",
      uploading: false,
    };
  },

  filters: {
    filterStatusVariant(status) {
      switch (status) {
        case statuses.INVALID_LOCATION:
          return "warning";
        case statuses.ERROR:
          return "danger";
        case statuses.COMPLETE:
          return "success";
        default:
          return "info";
      }
    },
  },

  computed: {
    i_fields() {
      return [
        {
          key: "index",
          label: this.$translate("index"),
        },
        {
          key: "reference_no",
          label: this.$translate("reference_no"),
        },
        {
          key: "customer_code",
          label: this.$translate("customer_code"),
        },
        {
          key: "upload_status",
          label: this.$translate("upload_status"),
        },
      ];
    },
    fieldData() {
      return orderHeaderFields
        .filter((x) => x.name != "schedule_at_date_format")
        .map((x) => {
          return {
            key: x.name,
            label: this.$translate(x.label),
          };
        });
    },
    templates() {
      return this.$store.state.orderTemplate.templates;
    },
    orderTypes() {
      return this.$store.state.orderType.items;
    },
    detailOptions() {
      return Object.keys(DetailedTypes).map((name) => ({
        name,
        item: DetailedTypes[name],
      }));
    },
    headerColumnsMap() {
      const x = { ...this.orderHeaderSettings };
      delete x.rowno;
      delete x.schedule_at_date_format;
      return x;
    },

    detailsColumnsMap() {
      const x = { ...this.orderDetailsSettings };
      delete x.rowno;
      return x;
    },

    uploadProgress() {
      let uploaded = this.i_orders.filter(
        (x) => x.upload_status != statuses.PENDING
      ).length;
      return Math.round((uploaded / this.i_orders.length) * 100);
    },
    completedUploads() {
      return this.i_orders.filter((x) => x.upload_status.includes("complete"))
        .length;
    },
    failedUploads() {
      return this.i_orders.filter((x) => x.upload_status.includes("error"))
        .length;
    },
    /////////////
    configurations() {
      return this.$store.getters["company/configurations"] || [];
    },

    headerKey() {
      return this.$store.state.company.settingKeys.orderHeaderKey;
    },
    detailKey() {
      return this.$store.state.company.settingKeys.orderDetailKey;
    },
  },

  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      console.log("Modal is about to be shown", bvEvent, modalId);
    });
    this.$root.$on("bv::modal::hide", () => {
      this.$emit("input", false);
    });
    Promise.all([
      this.$store.dispatch("itemType/fetchAll"),
      this.$store.dispatch("orderType/fetchAll"),
      this.$store.dispatch("company/fetch"),
      this.$store.dispatch("orderTemplate/fetchAll"),
    ]);
  },

  watch: {
    configurations: {
      handler: function (_configurations) {
        const { headerKey, detailKey } = this;
        try {
          const data = (
            (_configurations || []).find((x) => x.key === headerKey) || {}
          ).text_value;
          this.orderHeaderSettings = JSON.parse(data);
        } catch (err) {
          this.orderHeaderSettings = this.orderHeaderSettings;
        }
        try {
          const data = (
            (_configurations || []).find((x) => x.key === detailKey) || {}
          ).text_value;
          this.orderDetailsSettings = JSON.parse(data);
        } catch (err) {
          this.orderDetailsSettings = this.orderDetailsSettings;
        }
      },
      deep: true,
    },
    headerDataList: {
      handler: function (arr) {
        this.orderTemplateArray.splice(0);
        for (const header of arr) {
          const { order_type: order_type_name } = header;
          const order_type = this.orderTypes.find(
            (x) =>
              x.name.toLowerCase().trim() ==
              (order_type_name || "").toLowerCase().trim()
          );

          if (order_type) {
            const order_type_id = order_type.id;
            if (
              !this.orderTemplateArray.find(
                (x) => x.order_type_id == order_type_id
              )
            ) {
              const filtered_templates = this.templates.filter(
                (x) => x.order_type_id == order_type_id
              );
              this.orderTemplateArray.push({
                order_type_id,
                order_type_name,
                filtered_templates,
              });
            }
          }
        }
        console.log("orderTemplateArray", this.orderTemplateArray);
      },
      deep: true,
    },
  },

  methods: {
    /**
     * Where the value for the column index is -1, set the column setting to undefined.
     * @param data The data settings
     */
    preprocessDataSettings(data) {
      var dataCopy = { ...data };
      for (const [key, value] of Object.entries(dataCopy)) {
        dataCopy[key] = value == -1 ? undefined : value;
      }
      return dataCopy;
    },
    /**
     * Validates the form data based on whether it is the header data or details data.
     * @param data The form data
     * @param isheader whether the data is the header form data or not
     * @returns A list of errors if there are any or an empty list if there are none
     */
    validateDataSettings(data, isheader) {
      var errors = [];
      const fields = isheader ? orderHeaderFields : orderDetailsFields;
      for (const field of fields) {
        if (data[field.name] == undefined && field.required) {
          errors.push(
            `${capitalCase(field.name)} ${this.$translate("is_required")}`
          );
        }
      }
      return errors;
    },
    /**
     * Update the data settings with the form data if the data is valid
     * @param data The form data
     * @param isheader whether the data is the header form data or not
     */
    updateDataSettings(data, isheader) {
      console.log('the updated data',data);
      data = this.preprocessDataSettings(data);
      // validate data
      var res = this.validateDataSettings(data, isheader);

      // show errors if any
      if (res.length) {
        for (const err of res) {
          this.doToast(this.$translate("error"), err, "danger");
        }
        this.doToast(
          this.$translate("error"),
          this.$translate("update_setting_failed"),
          "danger"
        );
        // abort update due to errors
        return;
      }

      const text_value = JSON.stringify(data);
     
      const bool_value = false;

      const { headerKey, detailKey } = this;
      this.$store
        .dispatch("company/updateConfiguration", {
          key: isheader ? headerKey : detailKey,
          text_value,
          bool_value,
        })
        .then(() =>
          this.genericToast(
            this.componentName + this.$translate("settings"),
            this.$translate("updated"),
            "success",
            `${this.componentName} ${this.$translate("update_setting_success")}`
          )
        )
        .catch((err) => {
          this.doToast(
            this.$translate("error"),
            `${this.$translate("update_setting_alert")} ${
              err.response.data.error.message
            }`,
            "danger"
          );
        });
    },
    formatLocation({
      customer_address1: address1,
      customer_address2: address2,
      customer_city: city,
      country_code,
    }) {
      return {
        address1,
        address2,
        city,
        country_code,
      };
    },

    countryLookupSafe(progName, param) {
      try {
        return countryLookup[progName](param);
      } catch (err) {
        console.log(`safeRun- ${progName}-${param}-`, err.message);
        return null;
      }
    },

    parseErrors(errors) {
      const convertErrorMessage = (str) => {
        if (
          str.indexOf("Column not found") >= 0 &&
          str.indexOf("column 'type'") >= 0
        ) {
          return this.$translate("activity_type_not_found");
        }
        return str;
      };

      try {
        errors = JSON.parse(errors);
      } catch (err) {
        console.log("upload err", err);
      }
      const parsedErrors = [];
      if (typeof errors == "object") {
        if (Array.isArray(errors)) {
          for (const str of errors) {
            parsedErrors.push(convertErrorMessage(str));
          }
        } else {
          for (const key in errors) {
            parsedErrors.push(`${key}: ${errors[key]}`);
          }
        }
      } else {
        if (typeof errors == "string") {
          parsedErrors.push(convertErrorMessage(errors));
        } else if (errors) {
          parsedErrors.push("Unknown");
        }
      }
      return parsedErrors;
    },

    async processUploadData() {
      
      const _this = this;

      const parseNumber = (value) => {
        try {
          console.log("parseNumber before-", value);
          //return Number(value.replace(/[^0-9.-]+/g, ''))
          value = accounting.unformat(value) || 0;
          console.log("parseNumber after-", value);
          return value;
        } catch (err) {
          console.log("parseNumber err", err);
          return 0;
        }
      };
      const getCountryCode = (name) => {
        if (name) {
          name = capitalCase(name);
          let countryObj = _this.countryLookupSafe("byCountry", name);
          if (countryObj) return countryObj.iso2;
          countryObj = _this.countryLookupSafe("byIso", name);
          if (countryObj) return countryObj.iso2;
        }
        return "JM";
      };

      switch (this.detailType) {
        case DetailedTypes.Upload:
          if (!_this.detailsDataList.length) return false;
          break;
        case DetailedTypes.Template:
          //template
          if (this.orderTemplateArray.some((x) => !x.order_template_id))
            return false;
          break;
        default:
          break;
      }

      this.i_orders.splice(0);

      for (let _order of _this.headerDataList) {
        _order.items = [];
        switch (this.detailType) {
          case DetailedTypes.Upload:
            _order.items = _this.detailsDataList.filter(
              (y) => y.reference_no === _order.reference_no
            );
            _order.items = _order.items.map((_item) => {
              delete _item.reference_no;
              delete _item.customer_code;
              _item.price = parseNumber(_item.price);
              _item.quantity = parseNumber(_item.quantity);
              let item_tax_rate = parseNumber(_item.tax_rate);
              let item_tax_amount = parseNumber(_item.tax_amount);
              if (item_tax_rate == 0 && item_tax_amount > 0) {
                item_tax_rate =
                  (item_tax_amount * 100) / (_item.price * _item.quantity);
              }
              delete _item.tax_amount;
              _item.tax_rate = parseNumber(item_tax_rate);
              return _item;
            });
            break;
          case DetailedTypes.Template:
            //template
            {
              const {
                order_type_id,
                order_template_id,
              } = this.orderTemplateArray.find(
                (x) => x.order_type_name == _order.order_type
              );
              this.$set(_order, "order_type_id", order_type_id);
              this.$set(_order, "order_template_id", order_template_id);
              console.log("one love", {
                order_type_id,
                order_template_id,
              });
            }
            break;
          default:
            break;
        }

        _order.total_price = parseNumber(_order.total_price);
        _order.total_tax = parseNumber(_order.total_tax);
        _order.upload_status = statuses.PENDING;
        _order.error_list = [];
        _order.country_code = getCountryCode(_order.customer_country);
        _order.schedule_at_original = _order.schedule_at;
        // set a schedule field if it hasn't been set from the header file
        if (!_order.schedule_at) {
          const d = new Date();
          d.setDate(d.getDate() + 1);
          _order.schedule_at = d.toISOString().split("T")[0];
          this.orderHeaderSettings.schedule_at_date_format = "YYYY-MM-DD";
        }

        // change date to an acceptable format for the database
        _order.schedule_at = this.getProperScheduleAt(
          _order.schedule_at,
          this.orderHeaderSettings.schedule_at_date_format
        );
        console.log('acceptable date-------', _order.schedule_at);
        if (!_order.customer_city && _order.country_code === "JM") {
          _order.customer_city = "Kingston";
        }

        this.i_orders.push(_order);
      }
      return true;
    },

    getMonthIdxFromName(mm) {
      switch (mm.slice(0, 3).toLowerCase()) {
        case "jan":
          return 0;
        case "feb":
          return 1;
        case "mar":
          return 2;
        case "apr":
          return 3;
        case "may":
          return 4;
        case "jun":
          return 5;
        case "jul":
          return 6;
        case "aug":
          return 7;
        case "sep":
          return 8;
        case "oct":
          return 9;
        case "nov":
          return 10;
        case "dec":
          return 11;
      }
    },

    getProperScheduleAt(localDate, dateFormat) {

      console.log('format----------',dateFormat);
      console.log('local date---------',localDate);
      let _dd, _mm, _yy;
      switch (dateFormat) {
        case "DD/MM/YYYY":
        case "D/M/YYYY":
        case "D/M/YY":
        case "DD/MM/YY":
        case "DD-MMM-YY":
        case "DD-MMM-YYYY": {
          const [dd, mm, yy] = localDate.split(/\/|-/);
          _dd = parseInt(dd);
          _mm = parseInt(mm) - 1;
          _yy = parseInt(yy);
          if (_yy < 100) _yy = 2000 + _yy;
          break;
        }
        case "MM/DD/YYYY":
        case "M/D/YYYY":
        case "MM/DD/YY":
        case "M/D/YY": {
          const [mm, dd, yy] = localDate.split(" ");
          _dd = parseInt(dd);
          _mm = parseInt(mm) - 1;
          _yy = parseInt(yy);
          if (_yy < 100) _yy = 2000 + _yy;
          break;
        }

        case "MMMM DD, YYYY": {
          const [mm, dd, yy] = localDate.split(" ");
          _dd = parseInt(dd.slice(0, -1));
          _mm = this.getMonthIdxFromName(mm);
          _yy = parseInt(yy);
          break;
        }
        case "YYYY-MM-DD": {
          const [yy, mm, dd] = localDate.split(/\/|-/);
          _dd = parseInt(dd);
          _mm = parseInt(mm) - 1;
          _yy = parseInt(yy);
          if (_yy < 100) _yy = 2000 + _yy;
          break;
        }
      }
      
      return this.getLaravelFrLocalYYMMDDhhmm(_yy, _mm, _dd, 9, 0);
    },

    ///////////////////////////

    onComplete() {
      this.i_orders.splice(0);
      this.$emit("cancel");
    },
    setLoading(value) {
      this.uploading = value;
    },

    exportActivityHeaderCSV() {
      this.$refs.headerUploadDataSettings.exportSampleFile()
    },
    exportActivityDetailsCSV(){
      this.$refs.detailsUploadDataSettings.exportSampleFile()
    },

    validateScheduleDate(laravelDate) {
      const diff = this.getDateObject(laravelDate).getTime() - Date.now();
      const day = 24 * 60 * 60 * 1000;
      console.log("Diff:", diff);
      if (diff < -day) throw new Error("Scheduled Date Already Passed!");
      if (diff > 2 * 360 * day)
        throw new Error("Scheduled Date too far in the future!");
    },

    async uploadOrders() {
      // this.uploading = true
      const _this = this;
      // reset all errors to pending and empty the error list
      console.log("_this.i_orders", _this.i_orders);
      for (let i = 0; i < _this.i_orders.length; i++) {
        const x = _this.i_orders[i];
        if (x.upload_status == statuses.ERROR) {
          x.upload_status = statuses.PENDING;
          x.error_list = [];
          this.$set(_this.i_orders, i, x);
        }
      }

      const iterateUpload = async () => {
        const idx = _this.i_orders.findIndex(
          (x) => x.upload_status == statuses.PENDING
        );
        //check if completed
        if (idx === -1) return true;

        let nextItem = { ..._this.i_orders[idx] };
        var res = null;
        // try to find the location
        try {
          const {
            address1,
            address2,
            city,
            country_code,
          } = _this.formatLocation(nextItem);

          let location_error = false;
          try {
            const { latitude, longitude } = await _this.$store.dispatch(
              "locations/geocodeAddress",
              {
                address1,
                address2,
                city,
                country_code,
              }
            );
            nextItem = { ...nextItem, ...{ latitude, longitude } };
            console.log("nextItem", nextItem);
          } catch (err) {
            location_error = true;
            nextItem.upload_status = statuses.INVALID_LOCATION;
          }

          try {
            //upload order
            nextItem.schedule_at_original =nextItem.schedule_at_original; 
            this.validateScheduleDate(nextItem.schedule_at);
            nextItem.schedule_at_date_format =  this.orderHeaderSettings.schedule_at_date_format;
           

            res = await this.$store.dispatch("orders/uploadOrder", nextItem);
            // set status to complete if the upload was successful
            if (res.status_code == 200) {
              if (location_error) {
                nextItem.upload_status = statuses.INVALID_LOCATION;
              } else {
                nextItem.upload_status = statuses.COMPLETE;
              }
            } else {
              console.log("error res", res);
              nextItem.error_list = this.parseErrors(res);
              nextItem.upload_status = statuses.ERROR;
            }
          } catch (err) {
            nextItem.error_list = [err.message];
            nextItem.upload_status = statuses.ERROR;
          }
        } catch (error) {
          console.warn("uploadOrders warning:", error);
        } finally {
          console.log("nextItem----------", nextItem);
          _this.i_orders.splice(idx, 1, nextItem);
        }

        return await iterateUpload();
      };
      return await iterateUpload();
    },
  },
};
</script>
